import _debounce from "lodash/debounce"
import {passwordStrength, showPasswordStrengthOnBlade} from "@/libs/password"

export function initShowHidePassword(elements) {
    if (elements.showPass.length > 0) {
        elements.showPass.forEach((item) => {
            item.addEventListener(
                "click",
                (e) => {
                    e.preventDefault()
                    const input = item.previousElementSibling
                    const type = input.getAttribute("type") === "password" ? "text" : "password"
                    item.classList.toggle("view", type === "text")
                    input.setAttribute("type", type)
                },
                {passive: false}
            )
        })
    }
}

export function initPasswordStrengthChecker(elements) {
    elements.passwordFields.forEach((passwordField) => {
        passwordField.addEventListener(
            "input",
            _debounce(async (event) => {
                const {passwordStrength} = await import("@/libs/password.ts")
                passwordStrength(event.target.value)

                if (passwordField.parentNode.parentNode.classList.contains("blade")) {
                    const strengthStatus = passwordStrength(event.target.value) // Call the actual passwordStrength function
                    const className = strengthStatusClass(strengthStatus.level)
                    const passwordStrengthDiv = document.querySelector(".password-strength")
                    const strengthMessageDiv = document.querySelector(".password-message")
                    function strengthStatusClass(level) {
                        const classes = {
                            0: "strength-level-0",
                            1: "strength-level-1",
                            2: "strength-level-2",
                            3: "strength-level-3",
                            4: "strength-level-4",
                            5: "strength-level-5",
                        }
                        return classes[level] || ""
                    }
                    // Update the class for the password strength div
                    passwordStrengthDiv.className = `password-strength ${className}`

                    // Update the message inside the password message div
                    strengthMessageDiv.textContent = strengthStatus.message
                }
            }, 300),
            {passive: true}
        )
    })
}
